import DepositData from "../../entities/DepositData";
import PensionData from "../../entities/PensionData";
import RedemptionRightData from "../../entities/RedemptionRightData";
import UserFund from "../../entities/UserFund";
import {
  SET_GIMLAI_FUND_MOBILE,
  SET_AMIT_FUND_MOBILE,
  SET_ACTIVE_FUND,
  SET_PENSION_DATA_REDUX,
  SET_REDEMPTION_RIGHT_DATA_REDUX,
  SET_SALARY_DATA_REDUX,
  SET_ISDOC,
  SET_RIGHT_PER_EMP_REDUX,
  SET_FUND_COUNT
} from "../actions/DashboardActions";

const initialState: DashboardInitialState = {
  showAmitFundMobile: false,
  showGimlaiFundMobile: false,
  isDoc: false,
  activeFund: {} as UserFund,
  pensionDataRedux: {} as PensionData,
  redemptionRightDataRedux: {} as RedemptionRightData, 
  setFundCount: 0
};

const DashboardReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_AMIT_FUND_MOBILE:
      return {
        ...state,
        showAmitFundMobile: action.payload,
      };
    case SET_GIMLAI_FUND_MOBILE:
      return {
        ...state,
        showGimlaiFundMobile: action.payload,
      };
    case SET_ACTIVE_FUND:
      return {
        ...state,
        activeFund: action.payload,
      };
    case SET_PENSION_DATA_REDUX:
      return {
        ...state,
        pensionDataRedux: action.payload,
      };
    case SET_REDEMPTION_RIGHT_DATA_REDUX:
      return {
        ...state,
        redemptionRightDataRedux: action.payload,
      };

    case SET_SALARY_DATA_REDUX:
      return {
        ...state,
        setSalaryDataRedux: action.payload,
      };

    case SET_ISDOC:
      return {
        ...state,
        isDoc: action.payload,
      };

    case SET_RIGHT_PER_EMP_REDUX:
      return {
        ...state,
        setRightsPerEmpRedux: action.payload,
      };

      case SET_FUND_COUNT:
      return {
        ...state,
        setFundCount: action.payload,
      };

    default:
      return state;
  }
};

export interface DashboardInitialState {
  showAmitFundMobile: boolean;
  showGimlaiFundMobile: boolean;
  isDoc: boolean;
  activeFund: UserFund;
  pensionDataRedux: PensionData;
  redemptionRightDataRedux: RedemptionRightData; 
  setFundCount: number;
}

export default DashboardReducer;
